module.exports = __webpack_public_path__ + "img/4_118.8b12b753.png";